
export class animation_manager {
    constructor(images, configUrl, patchComponent, eventsStore) {
        this.images = images;
        this.configUrl = configUrl;
        this.patchComponent = patchComponent;
        this.eventsStore = eventsStore;
        this.currentIndex = 0;
        this.isPlaying = true;
        this.interval = null;
        this.animation_speed = null;
    }

    updateImage(index) {
        if (!this.images || !this.images.length) return;
        
        const currentImage = this.images[index];
        this.patchComponent.setTexture('color', `${this.configUrl}${currentImage.image_src}`);
        this.eventsStore.setGlobalState({ animatedDate: currentImage.date });
    }

    start(animation_speed) {
        this.animation_speed = animation_speed;
        if (this.interval) this.stop();
        
        this.isPlaying = true;
        this.interval = setInterval(() => {
            this.next();
        }, animation_speed);
    }

    stop() {
        this.isPlaying = false;
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    togglePlay() {
        if (this.isPlaying) {
            this.stop();
        } else {
            this.start(this.animation_speed);
        }
    }

    next() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.updateImage(this.currentIndex);
    }

    previous() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.updateImage(this.currentIndex);
    }

    destroy() {
        this.stop();
    }
}

export default animation_manager;
